import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { Pain } from './components/Pain';
import { ForWho } from './components/ForWho';
import { Sistema } from './components/Sistema';
import { Modules } from './components/Modules';
import { Bonos } from './components/Bonos';
import { Compare } from './components/Compare';
import { Oferta } from './components/Oferta';
import { Extra } from './components/Extra';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { FooterCta } from './components/FooterCta';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
const META_PIXEL_ID = '1012782631449952';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Avoid initializing the pixel more than once
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    // Official Meta Pixel base code
    ;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any;
      let t: HTMLScriptElement;
      let s: Element | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        // eslint-disable-next-line prefer-rest-params
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s?.parentNode?.insertBefore(t, s);
    })(w, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <Pain data-id="element-3" />
      <ForWho data-id="element-4" />
      <Sistema data-id="element-5" />
      <Modules data-id="element-6" />
      <Bonos data-id="element-7" />
      <Compare data-id="element-8" />
      <Oferta data-id="element-9" />
      <Extra data-id="element-10" />
      <Garantia data-id="element-11" />
      <Faq data-id="element-12" />
      <FooterCta data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchaseNotification data-id="element-15" />
    </div>;
}